export default {"src":"/_next/static/media/ecto-tools.9888cbf6.svg","height":38,"width":247,"blurWidth":0,"blurHeight":0};